import { tractorImageType } from '../../store/userSellTractorSurveySlice';

interface ITractorImageUploadButton {
  id: string;
  buttonText: string;
  type: tractorImageType;
}

export const tractorImageUploadButtonConstants: ITractorImageUploadButton[] = [
  { id: 'tractor-image-left', buttonText: '좌측면 (대표사진)', type: 'LEFT' },
  { id: 'tractor-image-front', buttonText: '정면', type: 'FRONT' },
  { id: 'tractor-image-back', buttonText: '후면', type: 'BACK' },
  { id: 'tractor-image-inner', buttonText: '실내', type: 'INNER' },
  { id: 'tractor-image-front-tier', buttonText: '앞 타이어', type: 'FRONTTIER' },
  { id: 'tractor-image-back-tier', buttonText: '뒷 타이어', type: 'BACKTIER' },
  { id: 'tractor-image-working-machine1', buttonText: '작업기', type: 'WORKINGMACHINE1' },
  { id: 'tractor-image-etc1', buttonText: '기타', type: 'ETC1' },
  { id: 'tractor-image-etc2', buttonText: '기타', type: 'ETC2' },
  { id: 'tractor-image-etc3', buttonText: '기타', type: 'ETC3' },
];

export const combineImageUploadButtonConstants: ITractorImageUploadButton[] = [
  { id: 'combine-image-left', buttonText: '좌측면 (대표사진)', type: 'LEFT' },
  { id: 'combine-image-front', buttonText: '정면', type: 'FRONT' },
  { id: 'combine-image-back', buttonText: '후면', type: 'BACK' },
  { id: 'combine-image-inner', buttonText: '실내', type: 'INNER' },
  { id: 'combine-image-left-track', buttonText: '좌 궤도바퀴', type: 'LEFTTRACK' },
  { id: 'combine-image-right-track', buttonText: '우 궤도바퀴', type: 'RIGHTTRACK' },
  { id: 'combine-image-etc1', buttonText: '기타', type: 'ETC1' },
  { id: 'combine-image-etc2', buttonText: '기타', type: 'ETC2' },
  { id: 'combine-image-etc3', buttonText: '기타', type: 'ETC3' },
];
